module.exports = __webpack_public_path__ + "static/media/1.1 Erper Details OfR_klein.872ecd9c.jpg";